import React from 'react';
import './Pages.css';

const Privacy: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Privacy Policy</h1>
        <p className="page-subtitle">Your privacy is our priority</p>
      </div>

      <div className="page-content legal-content">
        <p className="last-updated">Last updated: October 2025</p>

        <section className="content-section">
          <h2>1. Controller</h2>
          <div className="contact-box">
            <p>
              Dominik Reif<br />
              Waldstraße 14<br />
              91091 Großenseebach<br />
              Germany<br />
              📧 E-mail: <a href="mailto:support@dreif-ai.com">support@dreif-ai.com</a>
            </p>
          </div>
        </section>

        <section className="content-section">
          <h2>2. Purpose of this Privacy Policy</h2>
          <p>
            This Privacy Policy explains what personal data the GET AI PORTRAIT app ("App") collects,
            how it is used, and what rights you have under the General Data Protection Regulation (GDPR),
            the German Telecommunications-Telemedia Data Protection Act (TTDSG), and the EU AI Act
            (Regulation (EU) 2024/1689).
          </p>
        </section>

        <section className="content-section">
          <h2>3. What Data We Process</h2>

          <h3>a) Data Provided by Users</h3>
          <ul>
            <li><strong>Photos:</strong> Selfies you upload for AI portrait generation (5-10 photos per session)</li>
            <li><strong>Biometric Data:</strong> Facial landmarks detected via Apple Vision Framework for artistic transformation</li>
            <li><strong>AI Portraits:</strong> Generated portraits saved to your gallery (with your consent)</li>
            <li><strong>App Settings:</strong> Style preferences, notification settings, language</li>
            <li><strong>Support Inquiries:</strong> Email communications for customer support</li>
          </ul>

          <h3>b) Automatically Collected Data</h3>
          <ul>
            <li><strong>Device Information:</strong> Model, iOS version, app version</li>
            <li><strong>Anonymous Usage Statistics:</strong> Features used, session duration, portrait generation counts</li>
            <li><strong>Crash and Error Reports:</strong> Only with your consent via analytics prompt</li>
            <li><strong>Subscription Status:</strong> Premium unlock purchases, active subscriptions</li>
          </ul>

          <h3>c) Data NOT Collected</h3>
          <ul>
            <li>❌ Facial recognition profiles or biometric templates</li>
            <li>❌ Personal identification from facial features</li>
            <li>❌ Location data or GPS coordinates</li>
            <li>❌ Contact lists or social media accounts</li>
            <li>❌ Browsing history or third-party app usage</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>4. Purposes and Legal Bases of Processing</h2>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', margin: '15px 0' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left', backgroundColor: '#f8f9fa' }}>Purpose</th>
                  <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left', backgroundColor: '#f8f9fa' }}>Legal Basis</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Provision of the app and AI portrait generation</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Art. 6(1)(b) GDPR – Contract Performance</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Biometric data processing (facial features)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Art. 9(2)(a) GDPR – Explicit Consent</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Face detection for portrait framing</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Art. 6(1)(b) GDPR + Art. 9(2)(a) GDPR</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Error analysis and crash reporting</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Art. 6(1)(a) GDPR – Consent</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Usage analytics (anonymous)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Art. 6(1)(a) GDPR – Consent</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Subscription management (RevenueCat)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Art. 6(1)(b) GDPR – Contract Performance</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>AI model improvement (anonymized)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Art. 6(1)(f) GDPR – Legitimate Interest</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Legal obligations (e.g. accounting, tax)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Art. 6(1)(c) GDPR – Legal Obligation</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p><strong>You may withdraw your consent at any time with future effect in the app settings.</strong></p>
        </section>

        <section className="content-section">
          <h2>5. Third-Party Providers and Data Transfers</h2>
          <p>The app uses the following services for provision, processing, and analysis:</p>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', margin: '15px 0' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left', backgroundColor: '#f8f9fa' }}>Service</th>
                  <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left', backgroundColor: '#f8f9fa' }}>Provider</th>
                  <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left', backgroundColor: '#f8f9fa' }}>Purpose</th>
                  <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left', backgroundColor: '#f8f9fa' }}>Legal Basis / Safeguards</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Firebase</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Google LLC (USA)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Backend functions, job queue, analytics</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>EU Standard Contractual Clauses + EU-US Data Privacy Framework</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Replicate</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Replicate Inc. (USA)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>AI portrait generation (FLUX 1.1 Pro model)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Contract performance (Art. 6(1)(b) GDPR), SCC</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>OpenAI</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>OpenAI Inc. (USA)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>AI portrait generation (GPT-Image-1 / DALL-E 3)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Contract performance (Art. 6(1)(b) GDPR), SCC</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Google Vertex AI</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Google LLC (USA)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>AI portrait generation (Gemini 2.5 Flash image models)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Contract performance (Art. 6(1)(b) GDPR), SCC, no training on customer data</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Google Cloud Storage</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Google LLC (USA)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Temporary image storage during AI processing</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Contract performance (Art. 6(1)(b) GDPR), SCC, EU region (europe-west1)</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>CloudKit</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Apple Inc. (USA)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Portrait gallery sync across devices</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Contract performance (Art. 6(1)(b) GDPR), Apple privacy</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>RevenueCat</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>RevenueCat Inc. (USA)</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Subscription management, App Store integration</td>
                  <td style={{ border: '1px solid #ddd', padding: '12px' }}>Contract performance (Art. 6(1)(b) GDPR), SCC</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            <strong>All providers meet GDPR requirements; data transfers are based on Standard Contractual
            Clauses (SCC) or the EU-US Data Privacy Framework.</strong>
          </p>
        </section>

        <section className="content-section">
          <h2>6. Biometric Data Processing (Art. 9 GDPR)</h2>
          <p>
            <strong>🔒 We want to be completely transparent about how we handle facial data:</strong>
          </p>

          <h3>What We Do:</h3>
          <ul>
            <li>✅ Use Apple Vision Framework to detect faces in uploaded selfies</li>
            <li>✅ Extract facial landmarks (eyes, nose, mouth position) for artistic transformation</li>
            <li>✅ Process facial features to apply selected artistic styles</li>
            <li>✅ Generate AI portraits preserving your identity within artistic interpretation</li>
            <li>✅ Delete biometric data immediately after portrait generation completes</li>
          </ul>

          <h3>What We DON'T Do:</h3>
          <ul>
            <li>❌ Create or store biometric templates for identification</li>
            <li>❌ Use facial recognition to identify individuals</li>
            <li>❌ Build facial recognition databases or profiles</li>
            <li>❌ Share biometric data with third parties (except AI model providers for processing)</li>
            <li>❌ Use facial data for any purpose other than portrait generation</li>
          </ul>

          <h3>Your Consent:</h3>
          <p>
            Before uploading photos, you will be asked to provide <strong>explicit consent</strong> for
            biometric data processing. You can withdraw consent at any time by deleting your account and
            all associated data.
          </p>

          <h3>Data Retention:</h3>
          <ul>
            <li>Uploaded selfies: Deleted within 24 hours after processing completes</li>
            <li>Biometric landmarks: Deleted immediately after portrait generation</li>
            <li>AI portraits: Stored in your gallery until you delete them</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>7. Storage and Deletion</h2>
          <ul>
            <li><strong>Local Data:</strong> Portraits saved to your device remain exclusively on your device
            (or synced via CloudKit) until you delete them manually or uninstall the app.</li>
            <li><strong>Backend Jobs:</strong> Job metadata (style, submission time) stored for up to 7 days,
            then automatically deleted.</li>
            <li><strong>Uploaded Photos:</strong> Deleted from servers within 24 hours after processing completes.</li>
            <li><strong>Biometric Data:</strong> Deleted immediately after portrait generation (&lt; 60 seconds).</li>
            <li><strong>Subscription Data:</strong> Retained as long as subscription is active, deleted 90 days after cancellation.</li>
            <li><strong>Analytics Data:</strong> Anonymized after 90 days at the latest.</li>
          </ul>
          <p>
            <strong>You can request immediate deletion of all data at any time.</strong> See our{' '}
            <a href="/data-deletion">Data Deletion</a> page for instructions.
          </p>
        </section>

        <section className="content-section">
          <h2>8. AI-Assisted Processing and Transparency (EU AI Act)</h2>

          <h3>Use of AI:</h3>
          <p>
            GET AI PORTRAIT uses state-of-the-art AI models (FLUX 1.1 Pro, DALL-E 3, Gemini 2.5 Flash)
            to transform selfies into artistic portraits across 56+ styles.
          </p>

          <h3>Labeling:</h3>
          <p>
            All AI-generated portraits are clearly labeled as AI-generated in compliance with the EU AI Act.
            Watermarked previews include "AI Generated" labels. Full-resolution portraits include metadata
            indicating AI generation.
          </p>

          <h3>No Automated Decision-Making:</h3>
          <p>
            There is no profiling or automated scoring pursuant to Art. 22 GDPR. Portrait generation is
            user-initiated and artistic in nature, not for identification or decision-making.
          </p>

          <h3>Data Processing:</h3>
          <p>
            Photos are processed in pseudonymized form by AI model providers (Replicate, OpenAI). No permanent
            storage occurs without your consent. Providers delete processed images after generation completes.
          </p>

          <h3>Legal Notes:</h3>
          <ul>
            <li>AI portraits serve as artistic content and entertainment</li>
            <li>Portraits are NOT suitable for official identification documents</li>
            <li>You retain full ownership of generated portraits</li>
            <li>We do not claim copyright over AI-generated content you create</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>9. Security</h2>
          <p>We implement industry-standard security measures:</p>
          <ul>
            <li>✅ <strong>TLS Encryption:</strong> All data transfers encrypted via HTTPS</li>
            <li>✅ <strong>Secure Storage:</strong> Photos encrypted at rest on Firebase Cloud Storage</li>
            <li>✅ <strong>Keychain:</strong> API tokens stored securely in iOS Keychain</li>
            <li>✅ <strong>Access Controls:</strong> Role-based access restrictions on backend</li>
            <li>✅ <strong>Audit Logs:</strong> Backend operations logged for security monitoring</li>
            <li>✅ <strong>Third-Party Audits:</strong> All providers meet ISO 27001 or SOC 2 standards</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>10. Your Rights (GDPR Art. 15-21)</h2>
          <p>You have the right to:</p>
          <ul>
            <li><strong>Access (Art. 15 GDPR):</strong> Request a copy of all personal data we hold about you</li>
            <li><strong>Rectification (Art. 16 GDPR):</strong> Correct inaccurate or incomplete data</li>
            <li><strong>Erasure (Art. 17 GDPR):</strong> Delete your account and all associated data (see <a href="/data-deletion">Data Deletion</a>)</li>
            <li><strong>Restriction (Art. 18 GDPR):</strong> Limit processing of your data in certain circumstances</li>
            <li><strong>Data Portability (Art. 20 GDPR):</strong> Export your data in machine-readable format (JSON)</li>
            <li><strong>Object (Art. 21 GDPR):</strong> Object to processing based on legitimate interest</li>
            <li><strong>Withdraw Consent:</strong> Revoke biometric data processing consent at any time</li>
            <li><strong>Lodge Complaint (Art. 77 GDPR):</strong> File complaint with supervisory authority</li>
          </ul>

          <p>The competent supervisory authority is:</p>
          <div className="contact-box">
            <p>
              <strong>Bayerisches Landesamt für Datenschutzaufsicht</strong><br />
              Promenade 18<br />
              91522 Ansbach, Germany<br />
              <a href="https://www.lda.bayern.de" target="_blank" rel="noopener noreferrer">www.lda.bayern.de</a>
            </p>
          </div>

          <p>
            For detailed instructions on exercising your rights, visit our{' '}
            <a href="/gdpr">GDPR Rights</a> page.
          </p>
        </section>

        <section className="content-section">
          <h2>11. Minors</h2>
          <p>
            <strong>Age Restrictions:</strong>
          </p>
          <ul>
            <li>The app is intended for users <strong>18 years or older</strong></li>
            <li>We do not knowingly process data from minors under 16 (or 18 in certain jurisdictions)</li>
            <li>We do not process biometric data of minors without explicit parental consent</li>
            <li>If we discover underage use, we immediately delete all associated data</li>
          </ul>
          <p>
            Parents or guardians who believe their child has provided us with personal information should
            contact us immediately at{' '}
            <a href="mailto:privacy@dreif-ai.com">privacy@dreif-ai.com</a>.
          </p>
        </section>

        <section className="content-section">
          <h2>12. Changes to this Privacy Policy</h2>
          <p>
            We may update this Privacy Policy to comply with legal requirements or changes to the app's
            features. The current version is always available in the app and at{' '}
            <a href="https://getaiportrait.com/privacy" target="_blank" rel="noopener noreferrer">
              getaiportrait.com/privacy
            </a>.
          </p>
          <p>
            Significant changes will be announced in-app or via email. Continued use of our service after
            changes constitutes acceptance of the updated policy.
          </p>
        </section>

        <section className="content-section">
          <h2>13. Contact</h2>
          <p>Questions about data protection or exercising your rights:</p>
          <div className="contact-box">
            <p>
              <strong>General Inquiries:</strong><br />
              📧 <a href="mailto:support@dreif-ai.com">support@dreif-ai.com</a>
            </p>
            <p>
              <strong>Privacy & Data Protection:</strong><br />
              📧 <a href="mailto:privacy@dreif-ai.com">privacy@dreif-ai.com</a>
            </p>
            <p>
              <strong>Data Protection Officer:</strong><br />
              📧 <a href="mailto:dpo@dreif-ai.com">dpo@dreif-ai.com</a>
            </p>
            <p>
              <strong>Postal Address:</strong><br />
              Dominik Reif<br />
              Waldstraße 14<br />
              91091 Großenseebach<br />
              Germany
            </p>
          </div>
        </section>

        <p style={{ marginTop: '40px', textAlign: 'center', color: '#999' }}>
          End of Privacy Policy
        </p>

        <div style={{ marginTop: '20px', padding: '20px', backgroundColor: '#f0f9ff', borderRadius: '8px' }}>
          <p style={{ margin: 0, fontSize: '0.9em', color: '#666' }}>
            ✅ <strong>Legal compliance verified:</strong> GDPR / TTDSG / BGB / EU AI Act<br />
            ✅ <strong>Apple App Store Guidelines:</strong> 5.1.1 & 5.1.2 (Privacy)<br />
            ✅ <strong>Transparency, consent, and labeling requirements fulfilled</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
